import {
  PaymentStatus,
  normalizePaymentStatus,
} from "../constants/orderTypes";

export const CUSTOMER_CREATE_PAYMENT_PATH = "/payment/create";

export type CustomerCreatePaymentPayload = {
  amount: number;
  wallet_id: string;
  wallet: string;
  env: string;
};

/** Body posted to SDS `POST /v1/customer/payment/create` (payment-gateway top-up). */
export function buildCustomerCreatePaymentPayload(input: {
  amount: number;
  walletId: string;
  walletType: string;
  env: string;
}): CustomerCreatePaymentPayload {
  return {
    amount: input.amount,
    wallet_id: input.walletId,
    wallet: String(input.walletType || "").toLowerCase(),
    env: String(input.env || "").toLowerCase(),
  };
}

/** `callApi` unwraps SDS `{ data }`; keep a fallback for a nested envelope. */
export function paymentLinkFromCreateResponse(response: unknown): string {
  if (!response || typeof response !== "object") {
    return "";
  }
  const body = response as Record<string, any>;
  const link =
    body.link_url ||
    body.payments_link ||
    body?.data?.link_url ||
    body?.data?.payments_link ||
    "";
  return String(link).trim();
}

export function matchPaymentByLinkId(
  payments: unknown[],
  linkId: string
): Record<string, any> | undefined {
  const target = String(linkId);
  return (payments as any[]).find((item) => {
    const candidates = [
      item?.payment_id,
      item?.generated_link_id,
      item?.link_id,
      item?.payment_link_id,
      item?.order_id,
      item?.id,
    ]
      .filter(Boolean)
      .map((value) => String(value));
    return candidates.includes(target);
  });
}

export function isSuccessfulPaymentStatus(status?: string): boolean {
  const normalized = normalizePaymentStatus(status);
  return (
    normalized === PaymentStatus.PAID ||
    normalized === PaymentStatus.SUCCESS ||
    normalized === PaymentStatus.COMPLETED
  );
}
